/**
 * Sticky header
 */

const menu = document.querySelector(".site-header--type-absolute");
const singlePages = document.querySelector(".site-header--type-solid");

document.addEventListener("scroll", () => {

	var scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
	var CHECK_RATIO = 0.02;

	// use document.documentElement for chrome, firefox, ie or opera
	// and document.body for safari since that's where overflow is set in those browsers
	if (document.documentElement.scrollTop / scrollableHeight > CHECK_RATIO) {
		if (menu) {
			menu.classList.add("menu--alt");
		} else {
			singlePages.classList.add("single-menu--alt");
		}
		
	} else {
		if (menu) {
			menu.classList.remove("menu--alt");
		} else {
			singlePages.classList.remove("single-menu--alt");
		}
	}
});